<div class="what-page">
  <div class="background-wrapper">
    <section class="what-page__claim">
      <h2 class="what-page__claim__title">
        Wir entwickeln digitale
        <br />
        Produkte
      </h2>
      <p class="what-page__claim__text">
        Unsere Kernkompetenz ist die Entwicklung funktionaler
        <br />
        Software mit großem Fokus
        <br />
        auf herausragende UX und Design. Daten-
        <br />
        architektur, Analyse, Schnittstellen
        <br />
        und APIs liegen in unserer DNA.
      </p>
    </section>

    <section class="what-page__iteration">
      <div class="what-page__iteration__image">
        <div class="what-page__iteration__image__wrapper"></div>
      </div>
      <div class="what-page__iteration__claim">
        <p class="what-page__iteration__claim__text">
          Lernen, entwickeln, messen und
          <br />
          wieder lernen... ohne Unterbrechung.
        </p>
      </div>
    </section>

    <section class="what-page__what-we-do">
      <div class="what-page__what-we-do__wrapper">
        <h2 class="what-page__what-we-do__title">Entwickeln wie ein <span>Startup</span></h2>
        <p class="what-page__what-we-do__text">
          Unsere iterativen Entwicklungszyklen werden von <span class="underline">lean</span> Startups angewendet. Lassen Sie uns ein klares
          und <span class="underline">beeindruckendes MVP</span> erstellen. Validieren Sie Ihr Konzept mit einem Produkt, das jeder in
          Sekunden versteht. Finden Sie schnell heraus, ob ein <span class="underline">Geschäftsmodell</span> tragfähig ist! Fügen Sie
          <span class="underline">Funktionalität</span> hinzu, wenn Benutzer danach fragen oder wenn Ihr Produkt sich gut verkauft. Wir
          über-engineeren nicht!
        </p>
        <app-button text="Angebot anfordern" class="what-page__what-we-do__button"></app-button>
      </div>
    </section>
  </div>

  <section class="what-page__iteration-presentation">
    <div class="what-page__iteration-presentation__header">
      <h3 class="what-page__iteration-presentation__header__title">
        Iteration ist der Schlüssel
      </h3>
    </div>
    <div class="what-page__iteration-presentation__image-section">
      <app-svg-iteration [stateToShow]="statetoshow" class="what-page__iteration-presentation__image-section__svg"> </app-svg-iteration>
    </div>
    <ul class="what-page__iteration-presentation__slides">
      <li class="what-page__iteration-presentation__slides__slide -slide" [attr.stateToShow]="'ideation'">
        <p class="what-page__iteration-presentation__slides__slide__title">
          Ideenfindung
        </p>
        <p class="what-page__iteration-presentation__slides__slide__text">
          Unser Team bringt externe Perspektiven und Erfahrung in Ihre Idee ein. Gemeinsam tauchen wir tief in den Markt ein und
          identifizieren einen klaren Kundenbedarf.
          <br /><br />
          Wir erstellen Mock-ups und Prototypen, um eine Hypothese zu testen, sowie die Positionierung Ihres Wertversprechens und die beste
          Benutzererfahrung.
        </p>
      </li>
      <li class="what-page__iteration-presentation__slides__slide -slide" [attr.stateToShow]="'building'">
        <p class="what-page__iteration-presentation__slides__slide__title">
          Entwicklung
        </p>
        <p class="what-page__iteration-presentation__slides__slide__text">
          Unsere Kernkompetenz ist die Entwicklung benutzerfreundlicher Software und Datenverarbeitung.
          <br /><br />
          Wir erstellen ein beeindruckendes Minimum Viable Product, das in Ihre Datenarchitektur integriert wird. Das MVP hilft Ihnen, Ihre
          Hypothese zu überprüfen und wird durch Iterationen zur Grundlage für Ihr zukünftiges Produkt.
        </p>
      </li>
      <li class="what-page__iteration-presentation__slides__slide -slide" [attr.stateToShow]="'traction'">
        <p class="what-page__iteration-presentation__slides__slide__title">
          Zugkraft
        </p>
        <p class="what-page__iteration-presentation__slides__slide__text">
          Ein neues Produkt wird erst wertvoll, wenn es beginnt, Zugkraft zu entwickeln (Nutzer und Umsatz).
          <br /><br />
          Wir kennen die Tricks, um Ihr Produkt auf dem Markt zum Laufen zu bringen. Wir betreiben kontinuierlich Growth Hacking und
          verbessern es für eine bessere Benutzererfahrung.
        </p>
      </li>
    </ul>
  </section>
</div>
